import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_INSULATIONS,
  LINK_INSULATION_JOBS,
  UPDATE_INSULATION,
} from '../../../graph-queries/tar/insulation';
import { TInsulation } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import InsulationForm from '../InsulationForm/InsulationForm';
import classes from './JobAspects.module.scss';
import { columns } from '../../pages/Insulation/Insulations';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobInsulations: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_INSULATIONS, {
    variables: { jobId },
  });
  const [updateInsulation] = useMutation(UPDATE_INSULATION, {
    refetchQueries: [GET_JOB_INSULATIONS],
  });
  const [linkInsulationJobs] = useMutation(LINK_INSULATION_JOBS, {
    refetchQueries: [GET_JOB_INSULATIONS],
  });

  const onEditSubmit = (insulation: TInsulation) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = insulation;
    return updateInsulation({ variables: { input } });
  };

  const onLinkSubmit = (selection: TInsulation[], jobIds: number[]) => {
    return Promise.all(
      selection.map((insulation) =>
        linkInsulationJobs({
          variables: {
            insulationId: insulation.insulationId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TInsulation>
      aspectName="insulation"
      data={(data?.insulationsByJobId as unknown as TInsulation[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <InsulationForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Insulations</div>}
    />
  );
};

export default JobInsulations;
